import { useEffect, useState } from 'react';
import FilterSidebar from './components/FilterSidebar';
import PropertyList from './components/PropertyList';
import { fetchProperties } from './services/propertyService';
import './styles/global.css';

const DEFAULT_FILTERS = {
  city: [],
  locality: [],
  budget: [],
  propertyType: [],
  builder: [],
  possession: [],
  configuration: [],
};

const PreApprovedProjectsApp = () => {
  const [appliedFilters, setAppliedFilters] = useState(DEFAULT_FILTERS);
  const [searchText, setSearchText] = useState('');
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchProperties()
      .then((result) => {
        if (!cancelled) {
          setProperties(result.items);
          setError(null);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          console.error('Failed to load properties:', err);
          setError('Unable to load projects. Please try again later.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className='layout-spacing'>
      <div className="scl-pap page-wrapper">
        <div className='layout-padding'>
          <h3 className='heading'>Our Projects</h3>
          <div className="search-bar-wrap">
            <div className="search-bar-pre-approved">
              <span className="search-icon">
                <img src="/documents/d/global/search" alt="" width={24} height={24}/>
              </span>
              <input
                type="text"
                placeholder="Search by city, area/locality, project name or builder"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </div>
          <div className="page-layout">
            <FilterSidebar
              filters={appliedFilters}
              onApply={setAppliedFilters}
              properties={properties}
            />
            <PropertyList
              appliedFilters={appliedFilters}
              properties={properties}
              searchText={searchText}
              loading={loading}
              error={error}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreApprovedProjectsApp;
